module.exports = "<TextField type=\"password\" label=\"Enter a password\" />\n"